//@flow
import { gql, graphql } from "react-apollo"

const QUERY_CURRENT_FORECAST = gql`
  query FetchCurrentForecast {
    currentForecast {
      pm2_5
      pm10
      o3
      status
      highPollutionAdvisory
      healthWatch
      occurredAt
      restrictions {
        woodburning
        leafBlowers
        offRoadVehicles
      }
    }
  }
`

const withCAMMForecast = graphql(QUERY_CURRENT_FORECAST, {
  name: "camm"
})

export default withCAMMForecast



// WEBPACK FOOTER //
// ./src/Kiosk/queries/withCAMMForecast.js